import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const [bounce, setBounce] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => setBounce((b) => (b + 1) % 4), 600);
    return () => window.clearInterval(id);
  }, []);

  const emojis = ['🔍', '🗺️', '🧭', '✨'];
  const [emojiIndex, setEmojiIndex] = useState(0);
  useEffect(() => {
    const id = window.setInterval(() => setEmojiIndex((i) => (i + 1) % emojis.length), 800);
    return () => window.clearInterval(id);
  }, [emojis.length]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1.5rem',
        background:
          'radial-gradient(circle at 20% 20%, #fef3c7 0%, transparent 50%), radial-gradient(circle at 80% 80%, #dbeafe 0%, transparent 50%), linear-gradient(135deg, #fff7ed 0%, #f0fdfa 100%)',
        fontFamily:
          '"Segoe UI", system-ui, -apple-system, "Apple Color Emoji", "Segoe UI Emoji", sans-serif',
      }}
    >
      <div
        style={{
          maxWidth: '36rem',
          width: '100%',
          textAlign: 'center',
          background: 'rgba(255, 255, 255, 0.85)',
          backdropFilter: 'blur(8px)',
          borderRadius: '1.5rem',
          padding: '2.5rem 2rem',
          boxShadow:
            '0 20px 50px -10px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(255, 255, 255, 0.6)',
        }}
      >
        <div
          aria-hidden="true"
          style={{
            fontSize: '5rem',
            lineHeight: 1,
            marginBottom: '0.5rem',
            transform: `translateY(${bounce % 2 === 0 ? '0' : '-8px'})`,
            transition: 'transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)',
            userSelect: 'none',
          }}
        >
          {emojis[emojiIndex]}
        </div>

        <h1
          style={{
            fontSize: '5rem',
            fontWeight: 900,
            margin: '0 0 0.5rem',
            background: 'linear-gradient(135deg, #f59e0b 0%, #ef4444 50%, #8b5cf6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            letterSpacing: '-0.05em',
            lineHeight: 1,
          }}
        >
          404
        </h1>

        <h2
          style={{
            fontSize: '1.5rem',
            fontWeight: 700,
            color: '#1f2937',
            margin: '0 0 0.75rem',
          }}
        >
          Bu sayfayı bulamadık! 🤔
        </h2>

        <p
          style={{
            color: '#4b5563',
            fontSize: '1.05rem',
            lineHeight: 1.6,
            margin: '0 0 2rem',
          }}
        >
          Aradığın sayfa burada değil gibi görünüyor. Belki bir yere kaçtı,
          belki de hiç var olmadı. Merak etme, seninle birlikte bir çözüm
          bulabiliriz!
        </p>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.75rem',
            justifyContent: 'center',
          }}
        >
          <Link
            to="/"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.85rem 1.5rem',
              borderRadius: '0.75rem',
              background: 'linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%)',
              color: 'white',
              fontWeight: 600,
              textDecoration: 'none',
              boxShadow: '0 8px 20px -4px rgba(99, 102, 241, 0.4)',
              transition: 'transform 0.2s',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-2px)')}
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
          >
            🏠 Ana sayfaya dön
          </Link>

          <button
            type="button"
            onClick={() => navigate(-1)}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.85rem 1.5rem',
              borderRadius: '0.75rem',
              background: 'white',
              color: '#374151',
              fontWeight: 600,
              border: '2px solid #e5e7eb',
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = '#8b5cf6';
              e.currentTarget.style.color = '#8b5cf6';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = '#e5e7eb';
              e.currentTarget.style.color = '#374151';
            }}
          >
            ← Geri git
          </button>
        </div>

        <div
          aria-hidden="true"
          style={{
            marginTop: '2rem',
            display: 'flex',
            justifyContent: 'center',
            gap: '0.5rem',
            fontSize: '0.85rem',
            color: '#9ca3af',
          }}
        >
          <span>📚</span>
          <span>🎨</span>
          <span>🚀</span>
          <span>💡</span>
          <span>🌟</span>
        </div>
      </div>
    </div>
  );
}
